<svelte:options immutable={true} />

<script lang="ts">
	import katex from 'katex';
	import { onMount } from 'svelte';

	export let value = 'A=r(α+β+γ)/2';

	let ref: HTMLDivElement;
	onMount(() => {
		katex.render(value, ref, {
			throwOnError: false,
			displayMode: false,
			output: "mathml"
		});
	});
</script>

<div class="flex flex-col items-center">
	<div bind:this={ref}></div>
</div>
